/**
 * Saturo: Hinweis bei gesperrter Bundle-Menge.
 *
 * Bundle-Boxen haben eine feste Menge pro Warenkorbzeile (die App merged genau
 * eine Box), deshalb ist der Plus-Button dort deaktiviert. Ein deaktivierter
 * Button feuert aber gar kein Klick-Event — auch nicht an seine Umgebung —,
 * also liegt in cart-products.liquid eine transparente Fläche darüber. Klickt
 * jemand dorthin, blenden wir den Hinweis für ein paar Sekunden ein, statt ihn
 * dauerhaft in der Zeile stehen zu haben.
 *
 * Delegiert auf document, damit es auch für Zeilen gilt, die der Warenkorb
 * nach einem Update neu rendert.
 */

const VISIBLE_MS = 5000;
const timers = new WeakMap();

function showHint(overlay) {
  const cell = overlay.closest('.cart-items__quantity, td');
  const hint = cell?.querySelector('.cart-items__bundle-hint');
  if (!hint) return;

  hint.hidden = false;

  clearTimeout(timers.get(hint));
  timers.set(
    hint,
    setTimeout(() => {
      hint.hidden = true;
    }, VISIBLE_MS)
  );
}

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const overlay = target.closest('[data-bundle-lock-overlay]');
  if (overlay) showHint(overlay);
});
